import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

export const ColStyledProductCard = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      text-align: ${mediumUp ? 'left' : 'center'};
      ${!mediumUp && `padding: 0 0 ${rem(132)}`};
      margin-bottom: ${rem(40)};
      .nmx-icon {
        margin-bottom: ${rem(16)};
      }
    `;
  }}
`;

export const ColStyledMobileIconContainer = styled(Col)`
  ${({ theme }) => {
    const verticalPadding = rem(20);
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: ${rem(1)} solid ${theme.colors.neutral.grayLight1};
      padding-top: ${verticalPadding};
      padding-bottom: ${verticalPadding};
    `;
  }
}`;

export const ColStyledMobileContentContainer = styled(Col)`
  ${({ theme }) => {
    return css`
      display: flex;
      align-items: center;
      border-bottom: ${rem(1)} solid ${theme.colors.neutral.grayLight1};
    `;
  }
}`;

export const SectionContainerStyled = styled(SectionContainer)`
  padding-bottom: ${rem(20)};
`;

